import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import MarkdownScript from 'helpers/markdownScript';
import { i18nData } from 'helpers/i18n';

import imagePPALogo_en from '../../images/ppa_presents.png';
import imagePPALogo_fr_CA from '../../images/ppa_presents.fr_CA.png';
import imageKCLogo_en from '../../images/keepCoolNoPPAPresents.png';
import imageKCLogo_fr_CA from '../../images/keepCoolNoPPAPresents.fr_CA.png';

import markdownFile_en from './start.md';
import markdownFile_fr_CA from './start.fr_CA.md';

import imgLevel1Start from '../../images/level-1_start.png';
import imgLevel2Start from '../../images/level-2_start.png';
import imgLevel3Start from '../../images/level-3_start.png';
import imgLevel4Start from '../../images/level-4_start.png';
import imgLevel5Start from '../../images/level-5_start.png';
import imgLevel6Start from '../../images/level-6_start.png';

const imagePPALogo = i18nData({
  en: imagePPALogo_en,
  fr_CA: imagePPALogo_fr_CA
});

const imageKCLogo = i18nData({
  en: imageKCLogo_en,
  fr_CA: imageKCLogo_fr_CA
});

const levels = {
  '1': { img: imgLevel1Start },
  '2': { img: imgLevel2Start },
  '3': { img: imgLevel3Start },
  '4': { img: imgLevel4Start },
  '5': { img: imgLevel5Start },
  '6': { img: imgLevel6Start }
};

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadStart () {
  preloader([
    imagePPALogo_en,
    imagePPALogo_fr_CA,
    imageKCLogo_en,
    imageKCLogo_fr_CA,
    imgLevel1Start,
    imgLevel2Start,
    imgLevel3Start,
    imgLevel4Start,
    imgLevel5Start,
    imgLevel6Start
  ]);
}

function startSection ({ level, title, regionData, i18n: _ }) {
  const md_i18n = _(md);
  /* Level intro graphic */
  return (
    <Section id="start">

      <Slide
          id="ppa-presents"
          key="ppa-presents"
          bgColor="black"
          notes={md_i18n.getSubSectionAsHtml(`Level ${level} Start`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
            <img
                className="heading-image heading-image-before"
                src={_(imagePPALogo)} />
          </div>
        </div>
      </Slide>

      <Slide
          id="ppa-kc"
          key="ppa-kc"
          bgColor="black"
          notes={md_i18n.getSubSectionAsHtml(`Level ${level} Start`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
          <img className="kc-logo heading-image"
              src={_(imageKCLogo)} />
          </div>
        </div>
      </Slide>

      {/* Sanksrit for Vanessa */}
      {/* lokah samastah sukhino bhavantu */}
      {/* may all beings everywhere be at peace */}

      <Slide
          id="level"
          key="level"
          bgColor="black"
          notes={md_i18n.getSubSectionAsHtml(`Level ${level} Icon`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="title-image"><img
              className="heading-image heading-image-before"
              src={levels[level].img} />
            <Heading size={1}>
              <strong>{_(title)}</strong>
            </Heading>
            <Heading size={2}>
              <strong>{_`Level ${level}`}</strong>
            </Heading>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default startSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/01_start/startSection.jsx